import type { FeatureFlag } from '@/constants/featureFlags';

export enum CheckoutTemplate {
  SINGLE_PAYMENT_METHOD = 'SINGLE_PAYMENT_METHOD',
}

export enum PaymentMethodType {
  PAYPAL = 'paypal',
  CREDIT_CARD = 'card',
  APPLE_PAY = 'apple',
  GOOGLE_PAY = 'google',
}

export class CheckoutConfiguration {
  template?: CheckoutTemplate;
  availablePaymentMethods?: PaymentMethodType[];
}

export interface BootData {
  theme?: CheckoutTheme;
  checkoutTheme: CheckoutTheme;
  supportEmail: string;
  featureFlags: Record<FeatureFlag, boolean>;
  couponsConfiguration: CouponsConfiguration;
  publisherData: PublisherData;
  companyName: string;
  storeTabName: string;
  checkoutConfiguration?: CheckoutConfiguration;
}

export interface CheckoutTheme {
  _id: string;
  publisherId: string;
  publisherName: string;
  buttonColor: string;
  buttonTextColor: string;
  logo: string;
  primaryColor: string;
  textColor: string;
  backgroundImage: string;
  mobileBgImage: string;
  updatedAt: string;
}

export interface FeatureFlags {
  checkout_remove_field_labels: boolean;
  checkout_mobile_collapsed_breakdown: boolean;
  checkout_display_link_express_as_apm_box: boolean;
  checkout_display_paypal_as_apm_box: boolean;
  checkout_use_saved_card: boolean;
  checkout_payment_methods_divider: boolean;
  checkout_session_redirect_url: boolean;
  checkout_disable_payment_links_redirect_success_button: boolean;
  api_player_orders_v2: boolean;
  checkout_enforce_customer_email: boolean;
  checkout_disable_processing_screen: boolean;
  checkout_open_close_animation: boolean;
  checkout_partial_screen_mobile: boolean;
  dashboard_sdk_auto_updater_ui: boolean;
  orderEvents__remove_payment_method_from_unpaid: boolean;
  'checkout-support-expired-status': boolean;
  checkout_select_save_card_by_default: boolean;
  checkout_support_zendesk: boolean;
  checkout_rule_engine_and_router: boolean;
  checkout_payments_v3_flow: boolean;
  checkout_coupons: boolean;
  checkout_appcharge_receipts_paypal: boolean;
  checkout_disable_success_screen: boolean;
  checkout_deeplinks_disable_store: boolean;
  feature_estimateFee_reporting: boolean;
  payments_nuvei_unified_lambda: boolean;
  feature_collect_address_for_tax: boolean;
  feature_old_paypal_account_dispute_polling: boolean;
  feature_do_not_remit_tax: boolean;
  feature_collect_zip_for_tax_us_ca: boolean;
  checkout_appcharge_receipts_stripe_account: boolean;
  checkout_auto_close_redirect_success_page: boolean;
  Infra_be_stripe_new_payments_platform: boolean;
  checkout_decline_payment_on_forter_fraud: boolean;
}

export interface CouponsConfiguration {
  publisherId: string;
  enabled: boolean;
}

export interface PublisherData {
  companyName: string;
  companyId: string;
  storeTabName: string;
  id: string;
}
